import { Button, Descriptions, Modal } from "antd";
import dayjs from "dayjs";

import classes from "./BookingDetailsModal.module.scss";
import { buildBookingRef, capitalizeString } from "../../utils/helpers";

export default function BookingDetailsModal({
  open,
  onClose,
  booking = null,
  onExportPDF,
  onExportWord,
  isExportingPDF,
  isExportingWord,
}) {
  return (
    <Modal
      title={`Booking Details - ${
        booking?.id ? buildBookingRef(booking.id) : ""
      }`}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={"50vw"}
    >
      {booking?.id && (
        <div className={classes.wrapper}>
          <Descriptions
            bordered
            column={1}
            size="middle"
            labelStyle={{ width: "50%" }}
            contentStyle={{ width: "50%" }}
          >
            <Descriptions.Item label="Booking Date">
              {dayjs(booking.date).format("DD.MM.YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Site Arrival Time">
              {booking.time.slice(0, -3)}
            </Descriptions.Item>
            <Descriptions.Item label="Delivery Zone">
              {booking.milkrun
                ? `${capitalizeString(booking.deliveryZone)} (MILKRUN)`
                : capitalizeString(booking.deliveryZone)}
            </Descriptions.Item>
            <Descriptions.Item label="Driver Name">
              {`${booking.driver.name} ${booking.driver.surname}`}
            </Descriptions.Item>
            <Descriptions.Item label="License Plate">
              {booking.vehicle.licensePlate}
            </Descriptions.Item>
            <Descriptions.Item label="Vehicle Type">
              {booking.vehicle.type}
            </Descriptions.Item>
            <Descriptions.Item label="Driver License">
              {booking.driver.driverLicense}
            </Descriptions.Item>
            <Descriptions.Item label="Recipient/Contact">
              {`${booking.receiverName} ${booking.receiverPhone}`}
            </Descriptions.Item>
            <Descriptions.Item label="Cargo Type">
              {booking.cargoType}
            </Descriptions.Item>
          </Descriptions>
          <div className={classes.customFooter}>
            {!isExportingPDF.includes(booking.id) ? (
              <Button
                className={classes.exportButton}
                onClick={() => onExportPDF(booking.id)}
                type="primary"
              >
                Download Booking
              </Button>
            ) : (
              <Button className={classes.exportButton} disabled>
                Downloading...
              </Button>
            )}
            {!isExportingWord.includes(booking.id) ? (
              <Button
                className={classes.exportButton}
                onClick={() => onExportWord(booking.id)}
                type="primary"
              >
                Download Delivery Note
              </Button>
            ) : (
              <Button className={classes.exportButton} disabled>
                Downloading...
              </Button>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
